import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fadeOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-10px); }
`;

export const MessageBoxContainer = styled.div<{ messageType: "success" | "error" | null }>`
  z-index: 10000;
  left: 50%;
  transform: translateX(-50%);
  width: 30%;
  position: absolute;
  top: calc(var(--u) * 10);
  background-color: ${(props) =>
    props.messageType === "success" ? "#42b759" : props.messageType === "error" ? "tomato" : "transparent"};
  color: white;
  padding: var(--sp-12);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: var(--fs-base);
  margin-left: var(--sp-8);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;
